import classNames from 'classnames'
import React, { FC, ReactNode } from 'react'

import { IconRenderer, IconRendererType } from '@ui/icons/utils/IconRenderer'

import styles from './Badge.module.scss'

export type BadgeSize = 'md' | 'sm' | 'xs' | 'xxs'

export type BadgeType =
  | 'blue'
  | 'yellow'
  | 'orange'
  | 'danger'
  | 'green'
  | 'black'
  | 'primary'
  | 'purple'
  | 'outline'

export type BadgeContrast = 'high' | 'low'

export interface BadgeProps {
  children: ReactNode
  size?: BadgeSize
  type?: BadgeType
  contrast?: BadgeContrast
  leftIcon?: IconRendererType
  rightIcon?: IconRendererType
  onClick?: () => void
}

export const Badge: FC<BadgeProps> = ({
  children,
  size = 'sm',
  type = 'blue',
  contrast = 'low',
  leftIcon,
  rightIcon,
  onClick,
}) => {
  const iconSize: Record<BadgeSize, number> = { xxs: 0, xs: 14, sm: 16, md: 28 }

  return (
    <div
      className={classNames(
        styles.badge,
        styles[`size-${size}`],
        styles[`type-${type}`],
        styles[`contrast-${contrast}`],
        {
          [styles.clickable]: !!onClick,
        }
      )}
      onClick={onClick}
    >
      {leftIcon && size !== 'xxs' && (
        <div className={styles.leftIcon}>
          {leftIcon && <IconRenderer icon={leftIcon} size={iconSize[size]} />}
        </div>
      )}

      <div className={styles.textWrap}>{children}</div>

      {rightIcon && size !== 'xxs' && (
        <div className={styles.rightIcon}>
          {rightIcon && <IconRenderer icon={rightIcon} size={iconSize[size]} />}
        </div>
      )}
    </div>
  )
}
